const PlanState = {
    plans: [],
    subscribe: {},
    userPlan: { data: [] },
    planSummary: {}
};

export default PlanState;